"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const BaseLink_1 = __importDefault(require("../../../elementKit/baseLink/BaseLink"));
require("./credentialEarningCriteriaBlock.scss");
const credentialEarningCriteriaBlockTranslations_json_1 = __importDefault(require("./credentialEarningCriteriaBlockTranslations/credentialEarningCriteriaBlockTranslations.json"));
const master_1 = require("../../../constants/master");
const subdomains_1 = require("../../../constants/subdomains");
function CredentialEarningCriteriaBlock(props) {
    props.addTranslation(credentialEarningCriteriaBlockTranslations_json_1.default);
    const config = (0, master_1.getMasterConfig)();
    const showEarningCriteriaBlock = config.subDomain !== subdomains_1.nationalBlackLawyersSubdomain &&
        config.subDomain !== subdomains_1.nationalTrialLawyersSubdomain;
    return showEarningCriteriaBlock ? (react_1.default.createElement("div", { className: "earning-criteria-block" },
        react_1.default.createElement("span", { className: "block-title" }, props
            .translate(props.earningCriteriaHtml ? "earningCriteria" : "evidences")
            .toString()),
        props.earningCriteriaHtml ? (react_1.default.createElement("div", { className: "criteria-html ql-editor", dangerouslySetInnerHTML: {
                __html: props.earningCriteriaHtml,
            } })) : (react_1.default.createElement("ul", { className: "evidences" }, props.evidences.map((evidence, i) => (react_1.default.createElement("li", { key: evidence.id, className: "evidence" },
            react_1.default.createElement("span", { className: "s6", dangerouslySetInnerHTML: {
                    __html: evidence.title,
                } }),
            evidence.link && (react_1.default.createElement("span", { className: "s6", style: {
                    marginLeft: "5px",
                } },
                props.translate("seeSource").toString(),
                react_1.default.createElement(BaseLink_1.default, { className: "s6 underlined blue", href: evidence.link, text: evidence.link, title: evidence.title, openInNewTab: true })))))))))) : null;
}
exports.default = CredentialEarningCriteriaBlock;
